import { Link } from "react-router-dom";
import { useI18n } from "../context/I18nContext";
import Seo from "../components/Seo";
import { Overline } from "../components/Reveal";

export default function Legal({ kind }) {
  const { t } = useI18n();
  const data = t.legal[kind];

  return (
    <div className="min-h-screen bg-cream pb-24 pt-32 text-charcoal md:pt-40">
      <Seo title={`${data.title} — Wild Spoon`} description={t.seo.legal.description} />
      <div className="mx-auto max-w-3xl px-5">
        <Overline>Wild Spoon</Overline>
        <h1 className="mt-6 font-serif text-4xl md:text-5xl">{data.title}</h1>
        {data.blocks.map((b) => (
          <section key={b.h} data-testid={`legal-section-${b.h.slice(0, 12).replace(/\W/g, "")}`}>
            <h2 className="mt-10 font-serif text-xl md:text-2xl">{b.h}</h2>
            {b.p.map((p, i) => (
              <p key={i} className="mt-3 leading-relaxed text-charcoal/75">
                {p}
              </p>
            ))}
          </section>
        ))}
        <Link
          to="/"
          data-testid={`legal-${kind}-home`}
          className="mt-14 inline-block border-b border-terra pb-1 text-sm text-terra transition-colors hover:text-terra-dark"
        >
          ← Wild Spoon
        </Link>
      </div>
    </div>
  );
}
